import { Card, Flex, Space, Tag, Typography } from 'antd'
import { Profile as ProfileModel } from '../../models/Profile'
import { Profile } from '../profile/Profile'
import {
  ControlOutlined,
  CreditCardOutlined,
  PercentageOutlined,
} from '@ant-design/icons'
import i18n from '../../i18n/setupLocalization'
import LocalizationKeys from '../../i18n/LocalizationKeys'
import { useEffect, useState } from 'react'
import { Plan } from '../../models/Billing'
import { fetchPlan } from '../../services/ProfileBillingService'
import dayjs from 'dayjs'

const { Text, Title } = Typography

interface Props {
  profile: ProfileModel
}

export const SubscriptionSummaryCard = ({ profile }: Props) => {
  const [plan, setPlan] = useState<Plan | undefined>()
  const [isLoading, setIsLoading] = useState<boolean>(false)

  useEffect(() => {
    if (!profile.slug) {
      return
    }
    setIsLoading(true)
    fetchPlan(profile.slug)
      .then((plan) => {
        setPlan(plan)
      })
      .finally(() => {
        setIsLoading(false)
      })
  }, [profile])

  return (
    <Card
      loading={isLoading}
      styles={{ body: { height: '100%' } }}
      bordered
      style={{ height: '100%' }}
    >
      {plan && (
        <Flex
          vertical
          justify="space-between"
          style={{ height: '100%' }}
          gap={8}
        >
          <Flex justify="space-between" align="center">
            <Space direction="vertical">
              <Title level={5} className="m-0">
                <Space>
                  <CreditCardOutlined />
                  {i18n.t(
                    LocalizationKeys.Component.Subscription.SummaryCard.Plan,
                    { planName: plan.name }
                  )}
                </Space>
              </Title>
              <Text className="m-0">
                {i18n.t(
                  LocalizationKeys.Component.Subscription.SummaryCard
                    .NextPayment,
                  {
                    date: dayjs.unix(plan.nextPaymentAt ?? 0).format('MMMM D'),
                  }
                )}
              </Text>
            </Space>
            <Space direction="vertical">
              <Space>
                <Title className="m-0 price">{plan?.amount}</Title>
                <Text className="m-0">
                  /{' '}
                  {i18n.t(
                    plan.recurring.interval === 'month'
                      ? LocalizationKeys.Component.Subscription.SummaryCard
                          .Monthly
                      : LocalizationKeys.Component.Subscription.SummaryCard
                          .Annual
                  )}
                </Text>
              </Space>
            </Space>
          </Flex>
          <Flex
            justify="space-between"
            align="center"
            className="wrap-on-mobile"
            gap={8}
          >
            <Space direction="vertical"></Space>
            {plan.recurring.interval != 'year' && (
              <Tag
                color="purple"
                icon={<PercentageOutlined />}
                className="multi-line-tag "
              >
                {i18n.t(
                  LocalizationKeys.Component.Subscription.SummaryCard
                    .SaveWithAnnualPayment
                )}
              </Tag>
            )}

            <Profile.BillingPortalButton
              profileSlug={profile.slug}
              icon={<ControlOutlined />}
              size="large"
              type="primary"
            >
              {i18n.t(
                LocalizationKeys.Component.Profile.BillingPortal.BillingPortal
              )}
            </Profile.BillingPortalButton>
          </Flex>
        </Flex>
      )}
    </Card>
  )
}

export type SubscriptionSummaryCardType = {
  SummaryCard: typeof SubscriptionSummaryCard
}
